import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    primary: '#FF6B6B',     // Rojo pastel
    secondary: '#FFFFFF',   // Blanco puro
    background: '#2E2E2E',  // Gris oscuro
    backgroundAlt: '#4A4A4A', // Gris medio
    accent: '#FFABAB',      // Rojo pastel más claro
    textSecondary: '#CCCCCC', // Gris claro
    highlight: '#FFD1D1',    // Rojo pastel muy claro para hover
    border: 'rgba(255,255,255,0.1)'  // Borde sutil
  },
  fonts: {
    main: "'Poppins', sans-serif"
  },
  glassMorphism: {
    background: 'rgba(46, 46, 46, 0.85)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    blur: '10px',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
  }
};

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html, body {
    font-family: ${theme.fonts.main};
    background-color: ${theme.colors.background};
    color: ${theme.colors.secondary};
    min-height: 100vh;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden; /* Prevenir scroll horizontal en móviles */
    width: 100%;
    max-width: 100vw;
    position: relative;
  }
  
  body.modal-open {
    overflow: hidden;
  }
  
  main {
    padding-top: 70px; /* Espacio para la navbar fija */
    min-height: calc(100vh - 200px); /* Altura mínima para mantener footer abajo */
    
    @media (max-width: 768px) {
      padding-top: 60px;
    }
  }
  
  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${theme.colors.accent};
    }
  }
  
  button {
    cursor: pointer;
    font-family: ${theme.fonts.main};
  }
  
  p {
    line-height: 1.6;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.main};
    line-height: 1.2;
  }
  
  /* Estilos para mejorar la experiencia en móviles */
  input, 
  textarea, 
  button, 
  select {
    font-family: ${theme.fonts.main};
    font-size: 16px; /* Evitar zoom automático en iOS */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  
  @media (max-width: 768px) {
    * {
      -webkit-tap-highlight-color: transparent; /* Eliminar highlight al tocar en móviles */
    }
    
    /* Ajustar tamaños de texto para móviles */
    h1 {
      font-size: 2rem;
    }
    
    h2 {
      font-size: 1.5rem;
    }
    
    body {
      font-size: 16px;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .section {
    padding: 60px 0;
    
    @media (max-width: 768px) {
      padding: 40px 0;
    }
  }
  
  /* Glassmorphism */
  .glass {
    background: ${theme.glassMorphism.background};
    backdrop-filter: blur(${theme.glassMorphism.blur});
    -webkit-backdrop-filter: blur(${theme.glassMorphism.blur});
    border: ${theme.glassMorphism.border};
    box-shadow: ${theme.glassMorphism.shadow};
  }
  
  /* Animaciones */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.6s ease forwards;
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(255, 107, 107, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);
    }
  }
  
  .animate-pulse {
    animation: pulse 2s infinite;
  }
  
  /* Scrollbar personalizada */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: ${theme.colors.background};
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary};
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.accent};
  }
  
  /* Utilidades */
  .text-center {
    text-align: center;
  }
  
  .mt-1 { margin-top: 0.5rem; }
  .mt-2 { margin-top: 1rem; }
  .mt-3 { margin-top: 1.5rem; }
  .mt-4 { margin-top: 2rem; }
  .mt-5 { margin-top: 3rem; }
  
  .mb-1 { margin-bottom: 0.5rem; }
  .mb-2 { margin-bottom: 1rem; }
  .mb-3 { margin-bottom: 1.5rem; }
  .mb-4 { margin-bottom: 2rem; }
  .mb-5 { margin-bottom: 3rem; }
  
  /* Media queries */
  @media (max-width: 992px) {
    html {
      font-size: 95%;
    }
  }
  
  @media (max-width: 768px) {
    html {
      font-size: 90%;
    }
    
    .container {
      padding: 0 15px;
    }
  }
  
  @media (max-width: 480px) {
    html {
      font-size: 85%;
    }
  }
`;

export default GlobalStyles; 